import { render, staticRenderFns } from "./IndxHeads.vue?vue&type=template&id=0c392006&scoped=true"
import script from "./IndxHeads.vue?vue&type=script&lang=js"
export * from "./IndxHeads.vue?vue&type=script&lang=js"
import style0 from "./IndxHeads.vue?vue&type=style&index=0&id=0c392006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c392006",
  null
  
)

export default component.exports